import { Wrench, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export const MaintenanceBanner = ({ tone, text, code, hint, onOpen }) => (
  <div className={cn("flex flex-wrap items-center justify-between gap-3 rounded-xl border p-4",
    tone === "mnt" ? "border-purple-200 bg-purple-50" : "border-purple-300 bg-purple-100/60")} data-testid={`mnt-banner-${tone}`}>
    <div className="flex items-start gap-3">
      <Wrench size={18} className="mt-0.5 text-purple-700" />
      <div>
        <p className="text-sm font-bold text-purple-900">{text}</p>
        <p className="text-xs text-purple-800">{hint}</p>
      </div>
    </div>
    <button type="button" onClick={onOpen} data-testid={`mnt-banner-${tone}-link`}
      className="flex items-center gap-1.5 rounded-full border border-purple-300 bg-white px-3 py-1.5 font-mono text-xs font-bold text-purple-800 transition-colors hover:bg-purple-50">
      {code}<ArrowRight size={13} />
    </button>
  </div>
);
